import '.ag{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.iw{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.af{justify-content:center;}.ssr-plugin'
import '.an{align-items:flex-start;}.ssr-plugin'
import '.e0{padding:2rem;}.ssr-plugin'
import '.eg{background:var(--palette-white);}.ssr-plugin'
import '.b5{overflow:hidden;}.ssr-plugin'
import '.ba{position:absolute;}.ssr-plugin'
import '.gy{top:50%;}.ssr-plugin'
import '.h2{right:1rem;}.ssr-plugin'
import '.gz{transform:translateY(-50%);}.ssr-plugin'
import '.ln{width:120px;}.ssr-plugin'
import '.lo{height:120px;}.ssr-plugin'
import '.lp{z-index:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ek{z-index:1;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.lq{max-width:calc(100% - 140px);}.ssr-plugin'
import '.lr{font-size:4rem;}.ssr-plugin'
import '.cl{font-weight:700;}.ssr-plugin'
import '.lg{line-height:100%;}.ssr-plugin'
import '.ie{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ag l iw d e af an e0 eg b5"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="ba gy h2 gz ln lo lp d t af"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ag ek d e an u lq"
      >
        <div className="lr cl lg ie a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
